export default {
  fields: {
    subject_id: {
      readOnly: true,
    },
    subject_type: {
      readOnly: true,
    },
    created_at: {
      readOnly: true,
      type: 'date',
    },
    updated_at: {
      readOnly: true,
      type: 'date',
    },
    path: {
      readOnly: true,
    },
    url: {
      readOnly: true,
    },
  },
  relationships: {
    subject: {
      polymorphic: true,
    }
  }
}
